<template>
  <!--begin::sidebar menu-->
  <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
    <!--begin::Menu wrapper-->
    <div
      id="kt_app_sidebar_menu_wrapper"
      class="app-sidebar-wrapper hover-scroll-overlay-y mb-5"
      data-kt-scroll="true"
      data-kt-scroll-activate="true"
      data-kt-scroll-height="auto"
      data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
      data-kt-scroll-wrappers="#kt_app_sidebar_menu"
      data-kt-scroll-offset="5px"
      data-kt-scroll-save-state="true"
    >
      <KTUserMenu v-if="isLoggedIn"></KTUserMenu>
      <!--begin::Menu-->
      <div
        id="#kt_app_sidebar_menu"
        class="menu menu-column menu-rounded menu-sub-indention px-3"
        data-kt-menu="true"
      >
        <section class="mb-5">
          <div class="menu-content">
            <span class="menu-heading fw-bold text-uppercase fs-7 mb-5">
              Investments
            </span>
          </div>
          <menu-item
            v-for="item in investmentsMenuItems"
            :key="item.route"
            :menuItem="item"
          ></menu-item>
        </section>

        <section class="mb-5">
          <div class="menu-content">
            <span class="menu-heading fw-bold text-uppercase fs-7">
              Deal Proposal
            </span>
          </div>
          <menu-item
            v-for="item in investeeMenuItems"
            :key="item.route"
            :menuItem="item"
          ></menu-item>
        </section>

        <section class="mb-5">
          <div class="menu-content">
            <span class="menu-heading fw-bold text-uppercase fs-7">
              Deal support
            </span>
          </div>
          <menu-item
            v-for="item in investorMenuItems"
            :key="item.route"
            :menuItem="item"
          ></menu-item>
        </section>

        <section class="mb-5">
          <div class="menu-content">
            <span class="menu-heading fw-bold text-uppercase fs-7">
              INVESTMENT COMMUNITY
            </span>
          </div>
          <menu-item
            v-for="item in intermediaryMenuItems"
            :key="item.route"
            :menuItem="item"
          ></menu-item>
        </section>
      </div>
      <!--end::Menu-->
    </div>
    <!--end::Menu wrapper-->
  </div>
  <!--end::sidebar menu-->
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { sidebarMenuIcons } from "@/core/helpers/config";
import KTUserMenu from "@/layouts/main-layout/menus/UserMenu.vue";
import MenuItem from "@/layouts/main-layout/sidebar/menu-item.vue";

const investmentsMenuItems = [
  {
    route: "/investment/deals",
    svgIcon: "media/icons/menu/deals.svg",
    heading: "Available deals",
  },
  {
    route: "/investment/funds",
    svgIcon: "media/icons/menu/funds.svg",
    heading: "Fund Investments",
  },
  {
    route: "/investment/selected",
    svgIcon: "media/icons/menu/selected.svg",
    heading: "Selected deals",
  },
  {
    route: "/investment/archived",
    svgIcon: "media/icons/menu/archived.svg",
    heading: "Archived deals",
  },
];

const investeeMenuItems = [
  {
    route: "/proposal/deals",
    svgIcon: "media/icons/menu/your.svg",
    heading: "Your deals",
  },
  {
    route: "/proposal/new",
    svgIcon: "media/icons/menu/add.svg",
    heading: "Add deal",
  },
];

const intermediaryMenuItems = [
  {
    route: "/intermediary/list",
    svgIcon: "media/icons/menu/list.svg",
    heading: "List of intermediaries",
  },
  {
    route: "/intermediary/new",
    svgIcon: "media/icons/menu/become.svg",
    heading: "Become intermediary",
  },
];

const investorMenuItems = [
  {
    route: "/investor/list",
    svgIcon: "media/icons/menu/list.svg",
    heading: "List of investors",
  },
  {
    route: "/investor/new",
    svgIcon: "media/icons/menu/become.svg",
    heading: "Join investors",
  },
];

export default defineComponent({
  name: "sidebar-menu",
  components: {
    KTUserMenu,
    MenuItem,
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const scrollElRef = (ref < null) | (HTMLElement > null);
    const isLoggedIn = store.getters["user/isLoggedIn"];

    onMounted(() => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      investmentsMenuItems,
      investeeMenuItems,
      intermediaryMenuItems,
      investorMenuItems,
      sidebarMenuIcons,
      isLoggedIn,
    };
  },
});
</script>

<style lang="scss" scoped>
.menu-heading {
  color: #0e3167;
  padding: 0px 14px;
}
</style>
